import angular from 'angular';

import './controller.js';

import '../../core/main/factory/error';
import '../../core/main/factory/analytics';
import '../../main/factory/authentication';
import '../../main/directive/permissions/directive';

angular.module("merchant.application.main").run([
    "$rootScope", "$location", "$anchorScroll",
    "merchant.application.main.factory.authentication",
    "core.application.main.factory.analytics",
    function($rootScope, $location, $anchorScroll, Authentication, Analytics) {
        var nextPathAfterLogin;
        $rootScope.header = {};

        $rootScope.$on("$routeChangeStart", function(event, next) {
            if (next.requiresLogout) {
                if (Authentication.loggedIn()) { // if logged in, log out implicitly (PAYL-2404)
                    Authentication.logout();
                }
            } else if (next.requiresLogin) {
                // if the user is required to be logged in to access this page
                nextPathAfterLogin = encodeURIComponent($location.url());
                if (! Authentication.loggedIn()) {
                    // if they aren't logged in, redirect them to the login page instead
                    event.preventDefault();
                    $rootScope.$evalAsync(function() {
                        $location.path("login").search({next: nextPathAfterLogin}).replace();
                    });
                } else {
                    if (Authentication.loginHasExpired()) {
                        // if the user's authentication has expired then log them out
                        event.preventDefault();
                        $rootScope.$evalAsync(function() {
                            $location.path("logout").search({next: nextPathAfterLogin}).replace();
                        });
                    } else {
                        // otherwise extend the length of time they can stay logged in
                        Authentication.extendLoginExpiry();
                    }

                    if (next.permissions && next.permissions.length != 0 && ! Authentication.hasAnyPermissions(next.permissions)) {
                        // if they don't have permission to access the page then redirect to the default page
                        event.preventDefault();
                        $rootScope.$evalAsync(function() {
                            $location.path("/").replace();
                        });
                    }

                    if (next.channels && next.channels.length != 0 && ! Authentication.hasAnyChannel(next.channels)) {
                        // if they don't have permission to access the page then redirect to the default page
                        event.preventDefault();
                        $rootScope.$evalAsync(function() {
                            $location.path("/").replace();
                        });
                    }
                }
            }
        });

        $rootScope.$on("$routeChangeSuccess", function(event, next) {
            // when we change pages, ensure we scroll to the top of the page
            $anchorScroll();
            $rootScope.activePageName = next.name;
            $rootScope.applicationVisible = true;

            // let google analytics know that a page change has occurred
            Analytics.sendAmplitudeEvent("Changed path", {
                currentMerchant: Authentication.currentMerchant(),
                userId: Authentication.userId(),
                pageTo: $rootScope.activePageName
            });
            Analytics.sendPageView({
                pagePath: $location.url(),
                queryParametersToRemove: next.queryParametersToRemove
            });
        });
    }
]);

angular.module("merchant.application.main")
    .config(["$httpProvider", function($httpProvider) {
        $httpProvider.defaults.withCredentials = true;
        $httpProvider.interceptors.push("core.application.main.factory.error");
    }
]).config(["$routeProvider",
    function($routeProvider) {

        $routeProvider
            .when("/", {
                name: "home",
                templateUrl: "orders.html",
                requiresLogin: true,
                // PAYL-7092 ensure the consumer name isn't sent to google analytics
                queryParametersToRemove: ["consumerName"],
            })

            .when("/login", {
                name: "login",
                templateUrl: "login.html",
                requiresLogin: false,
            })

            .when("/logout", {
                name: "logout",
                templateUrl: "logout.html",
                requiresLogin: false,
            })

            .when("/ssoRedirect", {
                name: "okta",
                templateUrl: "okta.html",
                requiresLogin: false,
            })

            .when("/order/:orderId", {
                name: "order-detail",
                templateUrl: "order-detail.html",
                requiresLogin: true,
                permissions: ["VIEW_ORDER"]
            })

            .when("/settlements", {
                name: "settlements",
                requiresLogin: true,
                permissions: ["VIEW_SETTLEMENT_INFO"],
                reloadOnSearch: false,
                redirectTo: '/reconciliations'
            })

            .when("/reconciliations", {
                name: "reconciliations",
                templateUrl: "settlements.html",
                requiresLogin: true,
                permissions: ["VIEW_SETTLEMENT_INFO"],
                reloadOnSearch: false
            })

            .when("/card-reconciliations", {
                name: "card-reconciliations",
                templateUrl: "card-reconciliations.html",
                requiresLogin: true,
                permissions: ["VIEW_SETTLEMENT_INFO"],
                reloadOnSearch: false
            })

            .when("/online-card-reconciliations", {
                name: "online-card-reconciliations",
                templateUrl: "online-card-reconciliations.html",
                requiresLogin: true,
                permissions: ["VIEW_SETTLEMENT_INFO"],
                reloadOnSearch: false
            })

            .when("/settlement/:settlementId", {
                name: "settlement-detail",
                requiresLogin: true,
                reloadOnSearch: false,
                redirectTo: '/reconciliation/:settlementId'
            })

            .when("/reconciliation/:settlementId", {
                name: "reconciliation-detail",
                templateUrl: "settlement-detail-page.html",
                requiresLogin: true,
                reloadOnSearch: false
            })

            .when("/card-reconciliation/:settlementId", {
                name: "card-reconciliation-detail",
                templateUrl: "card-reconciliation-detail-page.html",
                requiresLogin: true,
                reloadOnSearch: false
            })

            .when("/online-card-reconciliation/:uuid", {
                name: "online-card-reconciliation-detail",
                templateUrl: "online-card-reconciliation-detail-page.html",
                requiresLogin: true,
                reloadOnSearch: false
            })

            .when("/ap-button-reconciliation/:settlementId", {
                name: "ap-button-reconciliation-detail",
                templateUrl: "ap-button-reconciliation-detail-page.html",
                requiresLogin: true,
                reloadOnSearch: false
            })

            .when("/settlement-summary/:settlementId", {
                name: "settlement-summary",
                requiresLogin: true,
                reloadOnSearch: false,
                redirectTo: "/reconciliation-summary/:settlementId"
            })

            .when("/reconciliation-summary/:settlementId", {
                name: "reconciliation-summary",
                templateUrl: "settlement-summary-page.html",
                requiresLogin: true,
                reloadOnSearch: false
            })

            .when("/card-reconciliation-summary/:settlementId", {
                name: "card-reconciliation-summary",
                templateUrl: "card-reconciliation-summary-page.html",
                requiresLogin: true,
                reloadOnSearch: false
            })

            .when("/online-card-reconciliation-summary/:uuid", {
                name: "online-card-reconciliation-summary",
                templateUrl: "online-card-reconciliation-summary-page.html",
                requiresLogin: true,
                reloadOnSearch: false
            })

            .when("/merchant-admin", {
                name: "merchant-admin",
                templateUrl: "merchant-admin-main-page.html",
                requiresLogin: true,
                permissions: ["VIEW_SHOP_CONFIGURATION", "EDIT_SHOP_CONFIGURATION"]
            })

            .when("/reset-ask", {
                name: "reset-ask",
                templateUrl: "reset-ask.html",
                requiresLogin: false,
                requiresLogout: true,
                // PAYL-7092 ensure the email isn't sent to google analytics
                queryParametersToRemove: ["e"],
            })

            .when("/reset-confirm", {
                name: "reset-confirm",
                templateUrl: "reset-confirm.html",
                requiresLogin: false,
                requiresLogout: true,
            })

            .when("/in-store/barcode", {
                name: "in-store-barcode",
                templateUrl: "barcode.html",
                requiresLogin: true,
                permissions: ["ACTIVATE_DEVICE", "CREATE_ORDER"],
                channels: ["IN_STORE"]
            })

            .when("/in-store/card/acquirer-details", {
                name: "card-acquirer-details",
                templateUrl: "card-acquirer-details.html",
                requiresLogin: true,
                permissions: ["VIEW_POS_CARD", "EDIT_POS_CARD"],
                channels: ["IN_STORE_CARD", "IN_STORE_CARD_ONLINE"]
            })

            .when("/in-store/card/invoicing-emails", {
                name: "card-invoicing-emails",
                templateUrl: "card-invoicing-emails.html",
                requiresLogin: true,
                permissions: ["VIEW_INVOICING_EMAIL", "EDIT_INVOICING_EMAIL"],
                channels: ["IN_STORE_CARD", "IN_STORE_CARD_ONLINE"]
            })

            .otherwise({
                redirectTo: "/",
                requiresLogin: false
            });

    }
]);
